// CyberClub
import React from 'react';
import TreasureHunt from 'views/TreasureHunt';

const CyberClubPage = () => {
  return <TreasureHunt />;
};

export default CyberClubPage;
